import { useQuery } from '@tanstack/react-query';
import { getStudioQuizOptions } from '@/api/query/studio';

export const useStudioQuizOptions = (language) =>
	useQuery({
		queryKey: ['studio-quiz-options', language],
		queryFn: () => getStudioQuizOptions(language),
		select: ({ data }) => data,
		staleTime: 5 * 60 * 1000,
	});
